import replace from 'ramda/src/replace'

export default replace(/[^a-zA-Z0-9. -]/g, '')
